document.addEventListener('click', async function (e) {
    const btnModalEditarMateriaPrima = e.target.closest('#btnModalEditarMateriaPrima');
    if (!btnModalEditarMateriaPrima) return;

    const idMateriaPrima = btnModalEditarMateriaPrima.getAttribute("data-id");
    const formEditar     = document.querySelector("#formEditarMateriaPrima");
    const modalEditar    = document.querySelector("#ModalEditarMateriaPrima");

    if (!formEditar || !idMateriaPrima || !modalEditar) {
        if (typeof lanzarAlerta === 'function') {
            lanzarAlerta("Faltan parámetros para editar la materia prima.", "alerta-roja");
        }
        return;
    }

    const requestOptions = {
        method: "GET",
        credentials: "include",
        headers: { "Content-Type": "application/json" },
        redirect: "follow",
    };

    const url = `/api/configuracion/materia-prima/infoMateriaPrima?idMateriaPrima=${idMateriaPrima}`;

    try {
        const response = await fetch(url, requestOptions);

        if (!response.ok) {
            throw new Error(`Error HTTP: ${response.status}`);
        }

        const result = await response.json();
        const data   = result.result[0];

        if (!data) {
            if (typeof lanzarAlerta === 'function') {
                lanzarAlerta("No se encontró información de la materia prima.", "alerta-roja");
            }
            setTimeout(() => { window.location.reload(); }, 1500);
            return;
        }

        modalEditar.classList.add('modal--show');

        const inputId        = formEditar.querySelector('#idMateriaPrimaEditar');
        const inputCodigo    = formEditar.querySelector('#codigoMpEditarDisplay');
        const inputDesc      = formEditar.querySelector('[name="descripcionMateriaPrima"]');
        const inputProveedor = formEditar.querySelector('[name="proveedorMateriaPrima"]');
        const divShitch      = formEditar.querySelector('#divShitchMateriaPrima');

        if (inputId)        inputId.value        = data.idMateriaPrima          || "";
        if (inputCodigo)    inputCodigo.value    = data.codigoMateriaPrima      || "";
        if (inputDesc)      inputDesc.value      = data.descripcionMateriaPrima || "";
        if (inputProveedor) inputProveedor.value = data.proveedorMateriaPrima   || "";

        const checked     = Number(data.estado) === 1 ? 'checked' : '';
        const textoEstado = Number(data.estado) === 1 ? 'ACTIVA' : 'INACTIVA';

        divShitch.innerHTML = `
            <span class="labelInfo">Estado:</span>
            <label class="switchEstado">
                <input
                    id="estado"
                    type="checkbox"
                    name="estado"
                    value="${data.estado}"
                    ${checked}
                >
                <span class="sliderEstado"></span>
                <span class="textoEstado">${textoEstado}</span>
            </label>
        `;

    } catch (error) {
        console.error("Error al obtener información de la materia prima:", error);
        if (typeof lanzarAlerta === "function") {
            lanzarAlerta("No se pudo cargar la información de la materia prima.", "alerta-roja");
        }
    }
});

document.addEventListener('submit', async (e) => {
    if (e.target.id === 'formEditarMateriaPrima') {
        e.preventDefault();
        const formulario = e.target;
        const btnSubmit  = formulario.querySelector('#btnEditarMateriaPrima');
        const spinner    = formulario.querySelector('#spinner');
        const formData   = new FormData(formulario);
        if (!formulario || !btnSubmit || !spinner) {
            if (typeof lanzarAlerta === 'function') {
                lanzarAlerta("Faltan parámetros para editar la materia prima.", "alerta-roja");
            }
            return;
        }
        btnSubmit.disabled = true;
        spinner.style.display = 'inline-block';
        try {
            const respuesta = await fetch('/api/configuracion/materia-prima/editar', {
                method: 'POST',
                body: formData
            });
            const json      = await respuesta.json();
            const status    = respuesta.status;
            const resultado = json.result;

            if (status !== 200) {
                alert("Error crítico al procesar la solicitud.");
                setTimeout(() => { window.location.reload(); }, 1500);
                return;
            }

            if (resultado.hayErrores) {
                resultado.errores.forEach(error => {
                    lanzarAlerta(error.mensaje, error.clase);
                    const campo = formulario.querySelector(`[name="${error.campo}"]`);
                    if (campo) campo.classList.add('inputRojo');
                });
                btnSubmit.disabled = false;
                spinner.style.display = 'none';
            }
            if (!resultado.hayErrores) {
                lanzarAlerta("Materia prima editada correctamente.", "alerta-verde");
                setTimeout(() => { window.location.reload(); }, 800);
            }

        } catch (error) {
            console.error("Error:", error);
            btnSubmit.disabled = false;
            spinner.style.display = 'none';
        }
    }
});
